export default "__VITE_ASSET__BluBnOsT__"